module.exports = __webpack_public_path__ + "img/editdisabled.18f88822.svg";